import moment from 'moment';

export function tabConfig () {
  'ngInject';

  if((!sessionStorage.getItem("start-time") || sessionStorage.getItem("reload-time")) && (window.location.pathname != sessionStorage.getItem("start-location"))){
    sessionStorage.setItem("start-time" , moment().format("MM-DD-hh-mm-ss"));
    sessionStorage.setItem("start-location" , window.location.pathname);
  }
  window.onbeforeunload = () => {
    sessionStorage.setItem("reload-time", moment().format("MM-DD-hh-mm-ss"));
  };
}